import type { ReactNode } from 'react'

import Link from 'next/link'
import { ArrowLeft } from 'lucide-react'
import { cn } from '@/lib/utils'

interface PageHeaderProps {
    title: ReactNode
    description?: ReactNode
    actions?: ReactNode
    back?: { href: string, label: string }
    className?: string
}

const PageHeader = ({ title, description, actions, back, className }: PageHeaderProps): ReactNode => {
    return (
        <div className={cn('mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between print:hidden', className)}>
            <div className='min-w-0'>
                {back && (
                    <Link
                        href={back.href}
                        className='mb-2 inline-flex items-center gap-1.5 rounded-md text-sm text-muted-foreground transition-colors hover:text-foreground focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-none'
                    >
                        <ArrowLeft className='size-4' />
                        {back.label}
                    </Link>
                )}

                <h1 className='font-heading text-2xl font-semibold tracking-tight text-foreground'>
                    {title}
                </h1>

                {description && (
                    <p className='mt-1 text-sm text-muted-foreground'>
                        {description}
                    </p>
                )}
            </div>

            {actions && (
                <div className='flex flex-wrap items-center gap-2'>
                    {actions}
                </div>
            )}
        </div>
    )
}

export default PageHeader
